import { toValue, watchEffect } from 'vue'
import type { MaybeRefOrGetter } from 'vue'
import { appConfig } from '@/config/app.config'

/**
 * Set the browser tab title, formatted with `appConfig.titleTemplate`.
 * Pass nothing to fall back to the bare product name. Accepts a ref or
 * getter so a page with a computed title keeps it up to date.
 */
export function useDocumentTitle(title?: MaybeRefOrGetter<string | undefined>): void {
  watchEffect(() => {
    const value = toValue(title)
    document.title = value ? appConfig.titleTemplate.replace('%s', value) : appConfig.name
  })
}
